export default {
  merchants: {
    id: 'payment_result_success_merchants',
    defaultMessage: `{merchantCount, plural,
      one {merchant}
      other {merchants}
    }`,
  },
}
